import { ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { TABLE_LAYOUT_FILL_CLASSES } from '@/util/constants';

type SettingsContentProps = {
  children: ReactNode;
  className?: string;
  fill?: boolean;
  /**
   * Centre in the space given instead of the viewport. The default offsets the SubNav on
   * the left, which is the wrong correction once a right-hand panel takes part of the width.
   */
  centerInParent?: boolean;
};

export const SettingsContent = ({
  children,
  className,
  fill,
  centerInParent,
}: SettingsContentProps) => (
  // Spacers keep content centered on the viewport, offsetting the SubNav's width on the left.
  <div className={cn('flex w-full', fill && 'h-full min-h-0')}>
    <div className="flex-1" />
    <div className={cn('w-full max-w-lg min-w-0', fill && TABLE_LAYOUT_FILL_CLASSES, className)}>
      {children}
    </div>
    <div className="flex-1" />
    {!centerInParent && (
      <div className="max-w-65 grow-2 basis-0 lg:max-w-66 xl:max-w-67 2xl:max-w-69" />
    )}
  </div>
);
